import CRUDService from "./base/CRUDService";

export class ReadpointCheckpointTargetService extends CRUDService {

  BASE_URL = '/ton/v1/readpoints-checkpoints-targets'

  getBaseURL() {
    return this.BASE_URL
  }

  createReadpointCheckpointTarget(data) {
    return super.getHttpRequest().post(this.getBaseURL(), data)
  }

  findOneByReadPointId(id) {
    return super.getHttpRequest().get(`${this.getBaseURL()}/readpoints/${id}`)
  }

  editReadpointCheckpointTargetById(id, data) {
    return super.getHttpRequest().put(`${this.getBaseURL()}/${id}`, data)
  }
}


// WEBPACK FOOTER //
// ./src/services/ReadpointCheckpointTargetService.js